import ShoppingCart from "../models/ShoppingCart";

export default {
  namespaced: true,
  state: {
    shoppingCart: {}
  },
  mutations: {
    setShoppingCart(state, shoppingCart) {
      state.shoppingCart = shoppingCart;
    }
  },
  actions: {
    async fetchShoppingCart({ commit }) {
      const shoppingCart = new ShoppingCart();
      const record = await shoppingCart.fetch();      

      commit('setShoppingCart', record);
    },
    async removeShoppingCartItem({ dispatch, getters }, itemId) {
      const shoppingCart = getters.getShoppingCart;

      await shoppingCart.removeItem(itemId);
      await dispatch('fetchShoppingCart');
    },
    async addShoppingCartItem({ dispatch, getters }, params) {
      const shoppingCart = getters.getShoppingCart;

      await shoppingCart.addItem(params);
      await dispatch('fetchShoppingCart');
    }
  },
  getters: {
    getShoppingCart(state) {
      return new ShoppingCart(state.shoppingCart);
    }
  }
}
